export default {
  home: '/clientEcosys/courierLevel/home'
}
